// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"c1144dfc","238":"0ca230c0","453":"4570c79b","716":"3422f85b"}[chunkId] + ".chunk.js";
};